import script from "./OrderSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSummary.vue?vue&type=script&setup=true&lang=js"

import "./OrderSummary.vue?vue&type=style&index=0&id=89da61f2&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89da61f2"]])

export default __exports__